import { Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import ProductCard from './ProductCard.jsx';

import 'swiper/css';

const MAX_ITEMS = 10;

/**
 * Home page product carousel: 2 cards per view on mobile, 3 on tablet,
 * 4 on desktop, up to 10 products. Arrow buttons live in the section
 * header and are wired up by class name (`carousel-prev-<id>` etc.).
 */
export default function ProductCarousel({ products = [], id }) {
  const items = products.slice(0, MAX_ITEMS);
  if (!items.length) return null;

  return (
    <div className="product-carousel">
      <Swiper
        modules={[Navigation]}
        navigation={{ prevEl: `.carousel-prev-${id}`, nextEl: `.carousel-next-${id}` }}
        spaceBetween={14}
        slidesPerView={2}
        slidesPerGroup={2}
        breakpoints={{
          720: { slidesPerView: 3, slidesPerGroup: 3, spaceBetween: 20 },
          1080: { slidesPerView: 4, slidesPerGroup: 4, spaceBetween: 24 },
        }}
      >
        {items.map((product) => (
          <SwiperSlide key={product.id}>
            <ProductCard product={product} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
